import React, { useState, useEffect } from 'react';
import API from '../../services/api';
import NoDataFound from '../../shared/NoDataFound';
import TableLoader from '../../shared/TableLoader';
import { SlButton, SlIcon, SlInput } from '@shoelace-style/shoelace/dist/react';
import { formatDate } from '../../utils/dateFormat';
import { debounce } from '../../utils/Debounce';
import Events from './Events';
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';
import { useForm, Controller } from 'react-hook-form'
import { Toast } from '../../shared/Toast';
import Select from 'react-select'
import EventsAccordion from './EventsAccordion';
import EventEngagement from './EventEngagement';
import {ScrollContainer} from 'react-indiana-drag-scroll';

function MyContacts() {
    const [contactData, setContactData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [search, setSearch] = useState("");
    const [addEvent, setAddEvent] = useState(false)
    const [contactDetails, setContactDetails] = useState()
    const [addContact, setAddContact] = useState(false)
    const [brandData, setBrandData] = useState([])
    const [addEngagement, setAddEngagement] = useState(false)
    const [edit, setEdit] = useState(false)
    const { register, handleSubmit, formState: { errors }, watch, setValue, reset, control } = useForm()
    const watchEmail = watch('official_email')
    const watchMobile = watch('official_mobile')
    const watchEmail1 = watch('personal_email1')
    const watchMobile1 = watch('personal_mobile')
    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    useEffect(() => {
        fetchContacts();
    }, [search]);
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
            event.preventDefault();
        }
    }

    const fetchContacts = async () => {
        try {
            setLoader(true);
            let res = await API({
                url: '/sales_contacts/get_contacts',
                method: 'POST',
                responseType: 'json',
                data: {
                    search
                }
            });
            if (res.code === 200) {
                setContactData(res.data);
            }
        } catch (error) {
            console.error('Error fetching contacts:', error);
        } finally {
            setLoader(false);
        }
    };
    const fetchBrands = async () => {
        try {
            let res = await API({
                url: '/sales_contacts/get_brands',
                method: 'POST',
                responseType: 'json',
                data: {}
            })
            if (res.code === 200) {
                setBrandData(res.data)
            }
        } catch (error) {
            console.error(error)
        }
    }
    const onSubmit = async (data) => {
        if(edit === true){
            try {
                let res = await API({
                    url:'/sales_contacts/edit_contact',
                    method:'POST',
                    responseType:'json',
                    data: {
                        designation: data.designation,
                        name: data.name,
                        official_email
                            : data.official_email,
                        official_mobile
                            : data.official_mobile,
                        personal_email
                            : data.personal_email,
                        personal_mobile: data.personal_mobile,
                        brand_id: data.brand_id,
                        contact_id:contactDetails.contact_id,
                        isAgency: data.isAgency
                    }
                })
                if(res.code === 200){
                    Toast('success','Contact updated successfully!')
                    fetchContacts()
                    handleClose()
                }
            } catch (error) {
                console.error(error)
            }
        }
        else{
            try {
                let res = await API({
                    url: '/sales_contacts/assign_contact',
                    method: 'POST',
                    responseType: 'json',
                    data: {
                        designation: data.designation,
                        name: data.name,
                        official_email
                            : data.official_email,
                        official_mobile
                            : data.official_mobile,
                        personal_email
                            : data.personal_email,
                        personal_mobile: data.personal_mobile,
                        brand_id: data.brand_id,
                        isAgency:data.isAgency || 0

                    }
                })
                if (res.code === 200) {
                    Toast('success', 'Contact added successfully!')
                    fetchContacts()
                    handleClose()
                }
                else {
                    Toast('error', res.data?.message)
                }
            } catch (error) {
                console.error(error)
            }
    }
}


    const handlePaste = async (e) => {
        
        try {
            const pastedData = JSON.parse(e.target.value);
            for (const key in pastedData) {
                if (pastedData.hasOwnProperty(key)) {
                    setValue(key, pastedData[key]);
                }
            }
            setValue('brand_id', { label: pastedData.brand_name, value: pastedData.brand_id })
        } catch (error) {
            console.error('Invalid JSON:', error);
        }
    };

    const handleClose = () => {
        setAddContact(false)
        reset()
        setValue('pastedData', null)
        setEdit(false)
    }

    const handleEdit = (data, brand_id, brand_name) => {
        setEdit(true)
        setValue('designation', data.designation)
        setValue('name', data.contact_name)
        setValue('official_email', data.official_email)
        setValue('official_mobile', data.official_mobile)
        setValue('personal_email', data.personal_email)
        setValue('personal_mobile', data.personal_mobile)
        setValue('brand_id', { label: brand_name, value: brand_id })
        setValue('isAgency', data.is_agency === 1 ? true : false)

    }

    return (
        <>
            <div className='d-flex gap-3 justify-end mb-3'>
                <SlInput size='small' onSlInput={debounce(handleSearch, 500)} placeholder='Enter Company'></SlInput>
                <SlButton size='small' variant='primary' onClick={() => {setAddContact(true); fetchBrands()}}>Add</SlButton>
            </div>
            <ScrollContainer>
            <table className='table table-bordered'>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Client</th>
                        <th>Contact Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Created Date</th>
                        <th>Events</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                {loader ? (
                    <TableLoader colspan={8} />
                ) : contactData.length ? (
                    <tbody>
                        {contactData?.map((contact, index) => (
                            contact.contacts?.map((item, i) => (
                                <tr key={`${index}-${i}`}>
                                    {i === 0 && (
                                        <>
                                            <td rowSpan={contact.contacts?.length}>{index + 1}</td>
                                            <td rowSpan={contact.contacts?.length}>{contact.brand_name}</td>
                                        </>
                                    )}
                                    <td>{item?.contact_name}</td>
                                    <td><p>{item.official_email}</p><p>{item.personal_email}</p></td>
                                    <td><p>{item.official_mobile}</p><p>{item.personal_mobile}</p></td>
                                    <td>{item.date ? formatDate(item.date) : null}</td>
                                    <td><EventsAccordion data={item.events} loadData={fetchContacts}/></td>

                                    <td>
                                        <div className='d-flex gap-3'>

                                            {contact.contacts[0]?.contact_id ? <><sl-tooltip content="Add events">
                                                <SlIcon library='lucide' name='calendar' className='cursor-pointer' onClick={() => { setAddEvent(true); setContactDetails(item) }} />
                                            </sl-tooltip>
                                            <sl-tooltip content="Add Engagement">
                                                <SlIcon library='lucide' name='users' className='cursor-pointer' onClick={() => { setAddEngagement(true); setContactDetails(item) }} />
                                            </sl-tooltip>
                                            <sl-tooltip content="Edit Contact">
                                                <SlIcon library='lucide' name='pencil' className='cursor-pointer' onClick={() => {setAddContact(true); handleEdit(item, contact.brand_id, contact.brand_name); setContactDetails(item) }} />
                                            </sl-tooltip>
                                            </> : "-"}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ))}
                    </tbody>
                ) : (
                    <NoDataFound colspan={8} />
                )}

            </table>
            </ScrollContainer>
            {
                addEvent && <Events show={addEvent} setShow={setAddEvent} details={contactDetails} loadData={fetchContacts} />
            }
            {
                addEngagement && <EventEngagement show={addEngagement} setShow={setAddEngagement} details={contactDetails} loadData={fetchContacts} />
            }
            <SlDrawer open={addContact} onSlAfterHide={() => { handleClose() }} onSlRequestClose={handleRequestClose}>
                <div className='mb-3'>
                    <label>Paste the contact details</label>
                    <textarea {...register("pastedData", { required: false, onChange : (e) =>handlePaste(e)  })} className='form-control'>
                    </textarea>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='mb-3'>
                        <label className='form-label'>Choose Brand</label>
                        <Controller name='brand_id'
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (

                                <Select {...field} name='brand_' isDisabled={edit} options={brandData}></Select>)}>
                        </Controller>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                            className="form-control"
                            placeholder="Client Name"
                            {...register("name", { required: true })}
                        />
                        {errors.name && <p className="text-red-600">Please Enter Name</p>}
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Designation</label>
                        <input
                            className="form-control"
                            placeholder="Designation"
                            {...register("designation", { required: true })}
                        />
                        {errors.designation && <p className="text-red-600">Please Enter Designation</p>}
                    </div>
                    <div className="border-b-[2px] border-dotted mb-3"></div>
                    <p className="text-gray-500 text-xs">Client Contact details</p>
                    <div className="mb-3">
                        <label className="form-label">Officail Mobile Number</label>

                        <input
                            placeholder="xxxxxxxxxx"
                            className='form-control'

                            {...register("official_mobile", { required: (!watchMobile && !watchEmail && !watchMobile1 && !watchEmail1), pattern: { value: /^(?:\+91[-\s]?)?(?:[6-9]\d{9}|0\d{10})$/
                            , message: "Invalid mobile number" } })}
                        />
                        {errors.official_mobile && <p className="text-red-600">{errors.official_mobile.message || 'Please Enter Mobile Number'}</p>}
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Official Email</label>

                        <input
                            placeholder="brand@way2news.com"
                            className='form-control'
                            {...register("official_email", { required: (!watchMobile && !watchEmail && !watchMobile1 && !watchEmail1), pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Invalid email" } })}
                        />
                        {errors.official_email && <p className="text-red-600">{errors.official_email.message || 'Please Enter Email'}</p>}
                    </div>

                    <div className="mb-3">

                        <label className="form-label">Personal Mobile Number</label>
                        <input
                            placeholder="xxxxxxxxxx"
                            className='form-control'

                            {...register("personal_mobile", { required: false })}
                        />

                        {errors.personal_mobile && <p className="text-red-600">Please Enter Mobile Number</p>}
                    </div>


                    <div className="mb-3">

                        <label className="form-label">Personal Email</label>
                        <input
                            placeholder="brand@way2news.com"
                            className='form-control'

                            {...register("personal_email", { required: false })}
                        />
                        {errors.personal_email && <p className="text-red-600">Please Enter Email</p>}
                    </div>
                    <div className="mb-3">
                        <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" {...register("isAgency", { required: false })} />
                        <label class="form-check-label" for="defaultCheck1">
                            IsAgency
                        </label>
                        </div>
              </div>
                    <div>
                        <button
                            className="w-100 bg-[#0079BC] px-4 py-3 text-white font-bold text-xs rounded"
                            type="submit"
                        >
                            Save Details
                        </button>
                    </div>
                </form>
            </SlDrawer>
        </>
    );
}

export default MyContacts;
